import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { createTheme, MantineProvider } from '@mantine/core';
import '@mantine/core/styles.css';
import './index.css';

import { InviteForm } from './pages/InviteForm';
import { NotFound } from './pages/NotFound';
import { ReviewProcess } from './pages/ReviewProcess';
import UpdateReview from './pages/UpdateReview';

import SystemProvider from './providers/SystemProvider';
import { MaintenanceContext } from './contexts/MaintenanceContext';
import MaintenanceRibbon from './components/MaintenanceRibbon';
import { maintenanceExternal } from './contexts/MaintenanceContext';

const theme = createTheme({});

const router = createBrowserRouter([
  { path: '/r/:companyName', element: <InviteForm /> },
  { path: '/r/:companyName/*', element: <InviteForm /> },
  { path: '/r/:companyName/video', element: <InviteForm /> },
  { path: '/r/:companyName/text', element: <InviteForm /> },
  { path: '/:inviteId', element: <ReviewProcess /> },
  { path: '/update-review/:reviewid/:token/', element: <UpdateReview /> },
  { path: '*', element: <NotFound /> },
]);

function MaintenanceWrapper() {
  const [maintenanceMode, setMaintenanceMode] = useState(false);
  const [maintenanceMessage, setMaintenanceMessage] = useState("");

  // 🔥 Wire axios into React state!
  maintenanceExternal.setMode = setMaintenanceMode;
  maintenanceExternal.setMessage = setMaintenanceMessage;

  return (
    <MaintenanceContext.Provider value={{
      maintenanceMode,
      setMaintenanceMode,
      maintenanceMessage,
      setMaintenanceMessage,
    }}>
      
      {/* 🔥 GLOBAL RIBBON ABOVE ALL APP PAGES */}
      {maintenanceMode && (
        <MaintenanceRibbon message={maintenanceMessage} />
      )}

      <RouterProvider router={router} />
    </MaintenanceContext.Provider>
  );
}


ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <MantineProvider theme={theme}>
      <SystemProvider>
        <MaintenanceWrapper />
      </SystemProvider>
    </MantineProvider>
  </React.StrictMode>
);
